import { MdClose } from "react-icons/md";
import { getAvatarUrl, getImageUrl } from "src/Common/common";

const DEFAULT_AVATAR = "/images/common/default_avatar.png";

/**
 * One chosen recipient: avatar, name over address, and a way to drop them.
 * Shared by the scheduled report modal and the service ticket editor so the
 * two read as the same control.
 */
const RecipientChip = ({ name, email, avatar, onRemove }) => (
  <div className="flex items-center gap-2 bg-[#EEF0F9] rounded-[6px] px-2 py-[6px]">
    <span className="w-5 h-5 rounded-full overflow-hidden bg-[#C9CEE2] shrink-0">
      <img src={avatar ? getAvatarUrl(avatar) : getImageUrl(DEFAULT_AVATAR)} alt="" className="w-5 h-5 object-cover" />
    </span>
    <span className="flex flex-col">
      {name && (
        <span className="font-OpenSansRegular text-[12px] leading-[18px] tracking-[0.12px] text-titleColor">
          {name}
        </span>
      )}
      <span className="font-OpenSansRegular text-[12px] leading-[18px] tracking-[0.12px] text-[#7C829A]">{email}</span>
    </span>
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onRemove();
      }}
      className="text-[#7C829A] hover:text-titleColor"
    >
      <MdClose size={12} />
    </button>
  </div>
);

export default RecipientChip;
